import createLogger from '@/utils/logger'

// LocalStorage key for coupon
const BRANDING_CODE_STORAGE_KEY = 'greatly_branding_code'
const SKIP_BRANDING_CODE_CAPTURE_STORAGE_KEY = 'skip_branding_code_capture'
const logger = createLogger('components/stripeCoupon')

// Function to save coupon to localStorage
export const saveBrandingCodeToStorage = (brandingCode: string | null) => {
  try {
    if (brandingCode) {
      localStorage.setItem(BRANDING_CODE_STORAGE_KEY, brandingCode)
      logger.log('Branding code saved to localStorage:', brandingCode)
    } else {
      localStorage.removeItem(BRANDING_CODE_STORAGE_KEY)
      logger.log('Branding code removed from localStorage')
    }
  } catch (error) {
    logger.error('Error saving branding code to localStorage:', error)
  }
}

// Function to load coupon from localStorage
export const loadBrandingCodeFromStorage = (): string | null => {
  try {
    const stored = localStorage.getItem(BRANDING_CODE_STORAGE_KEY)
    if (stored) {
      logger.log('Branding code loaded from localStorage:', stored)
      return stored
    }
  } catch (error) {
    logger.error('Error loading branding code from localStorage:', error)
  }
  return null
}

export const saveSkipBrandingCodeCaptureToStorage = (skip: boolean | null) => {
  if (skip === null) {
    sessionStorage.removeItem(SKIP_BRANDING_CODE_CAPTURE_STORAGE_KEY)
  } else {
    sessionStorage.setItem(SKIP_BRANDING_CODE_CAPTURE_STORAGE_KEY, skip ? 'true' : 'false')
  }
}

export const loadSkipBrandingCodeCaptureFromStorage = (): boolean => {
  const stored = sessionStorage.getItem(SKIP_BRANDING_CODE_CAPTURE_STORAGE_KEY)
  if (stored) {
    return stored === 'true'
  }
  return false
}
